<section class="pricing-card rcs-settings" [formGroup]="form" data-testid="user-rcs-settings">
  <h5 class="section-title"><i class="fa fa-commenting"></i>RCS</h5>

  <!-- Responsável comercial (acompanhamento de agentes, 17tm466frtx): quem a tela de
       Acompanhamento e os lembretes de "parado" avisam. Grava sozinho (rota própria), por
       isso o próprio botão Salvar — só aparece pra quem também vê a prévia (rota de admin). -->
  <div class="rcs-account-manager" *ngIf="canPreview" data-testid="rcs-account-manager">
    <div class="filter-field">
      <label for="rcs_account_manager_id">Responsável comercial</label>
      <select id="rcs_account_manager_id" class="form-select" [(ngModel)]="accountManagerDraft"
        [ngModelOptions]="{ standalone: true }" data-testid="select-account-manager">
        <option value="">Sem responsável</option>
        <option *ngFor="let manager of accountManagers" [value]="manager.id">{{ manager.name }}</option>
      </select>
      <small class="field-hint">
        Quem recebe o aviso de agente parado e os lembretes do cliente sem resposta. Sem responsável, caem nos
        admins do RCS, como hoje.
      </small>
    </div>
    <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="saveAccountManager()"
      [disabled]="!accountManagerDirty" [appLoadingButton]="savingAccountManager" data-testid="btn-save-account-manager">
      Salvar responsável
    </button>
  </div>

  <div class="rcs-flag" data-testid="switch-user-rcs-enabled">
    <app-switcher id="rcs_enabled" label="Habilitar RCS?" display="block"
      tooltip="Libera o menu RCS do cliente: cadastro de agente, envio em massa e etapa RCS na automação. O envio só sai com agente ativo e rota RCS."
      [checked]="rcsEnabled" (checkedChange)="setRcsEnabled($event)"></app-switcher>
  </div>

  <div class="filter-row">
    <div class="filter-field">
      <label for="broadcast_rcs_fractionation_route">RCS · envio em massa</label>
      <select id="broadcast_rcs_fractionation_route" class="form-select"
        formControlName="broadcast_rcs_fractionation_route" data-testid="select-rcs-broadcast-route">
        <option [ngValue]="null">Sem rota RCS</option>
        <option *ngFor="let route of rcsRoutes; trackBy: trackByRouteId" [ngValue]="route.id">
          {{ route.name }}{{ route.active === false ? ' (desativada)' : '' }}
        </option>
      </select>
      <small class="field-error" *ngIf="isInactive('broadcast_rcs_fractionation_route')">
        Esta rota está desativada: o envio em massa RCS não sai por ela.
      </small>
    </div>

    <div class="filter-field">
      <label for="automation_rcs_fractionation_route">RCS · automação</label>
      <select id="automation_rcs_fractionation_route" class="form-select"
        formControlName="automation_rcs_fractionation_route" data-testid="select-rcs-automation-route">
        <option [ngValue]="null">Sem rota RCS</option>
        <option *ngFor="let route of rcsRoutes; trackBy: trackByRouteId" [ngValue]="route.id">
          {{ route.name }}{{ route.active === false ? ' (desativada)' : '' }}
        </option>
      </select>
      <small class="field-error" *ngIf="isInactive('automation_rcs_fractionation_route')">
        Esta rota está desativada: a etapa RCS da automação não sai por ela.
      </small>
    </div>
  </div>

  <small class="field-hint">
    O SMS de fallback do RCS usa a rota de SMS da mesma origem: envio em massa usa a de massa, automação usa a de
    automação.
  </small>

  <div class="alert alert-warning pricing-notice mt-3" *ngIf="routesLoaded && !routesError && !rcsRoutes.length"
    data-testid="no-rcs-routes">
    <i class="fa fa-exclamation-triangle"></i>
    <span>Nenhuma rota RCS cadastrada. Crie uma em Operação › Fracionamentos, na tab RCS.</span>
  </div>

  <div class="alert alert-danger pricing-notice mt-3" *ngIf="routesError" data-testid="rcs-routes-error">
    <i class="fa fa-exclamation-triangle"></i>
    <span>Não foi possível carregar as rotas RCS.</span>
  </div>

  <div class="alert alert-warning pricing-notice mt-3" *ngIf="missingRoutes" data-testid="rcs-missing-routes">
    <i class="fa fa-exclamation-triangle"></i>
    <span>RCS ligado sem as duas rotas RCS: o cliente vê o menu, mas a origem sem rota <strong>não envia</strong>.</span>
  </div>

  <!-- Por onde o RCS sai: agente ativo × origem × operadora, com as rotas SALVAS. -->
  <div class="rcs-preview" *ngIf="userId && canPreview" data-testid="rcs-route-preview">
    <div class="rcs-preview__head">
      <h6 class="subsection-title">Por onde o RCS sai agora</h6>
      <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="loadPreview()"
        [appLoadingButton]="previewLoading" data-testid="btn-reload-preview">
        <i class="fa fa-refresh"></i>
        Atualizar
      </button>
    </div>

    <app-skeleton *ngIf="previewLoading" variant="table-row" [count]="2" [columns]="4"
      label="Calculando a divisão"></app-skeleton>

    <p class="field-error" *ngIf="!previewLoading && previewError" data-testid="preview-error">{{ previewError }}</p>

    <p class="muted" *ngIf="!previewLoading && !previewError && !preview.length" data-testid="preview-empty">
      Nenhum agente ativo. O cliente cadastra a marca no menu RCS, e ela é ativada em Admin › RCS (Acompanhamento).
    </p>

    <div class="table-responsive" *ngIf="!previewLoading && !previewError && preview.length">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>Origem</th>
            <th>Agente ativo</th>
            <th *ngFor="let carrier of carriers">{{ carrier }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of preview" data-testid="preview-row">
            <td>{{ originLabels[row.origin] || row.origin }}</td>
            <td>
              <span class="agent-name">
                <span class="agent-mono agent-mono--sm" [style.--agent-color]="row.agent?.color || null" aria-hidden="true">
                  {{ (row.agent?.name || '?').charAt(0).toUpperCase() }}
                </span>
                {{ row.agent?.name }}
              </span>
            </td>
            <td *ngFor="let carrier of carriers" data-testid="preview-cell">
              <span class="blocked" *ngIf="isBlocked(row.carriers?.[carrier]); else split">bloqueado · alerta</span>
              <ng-template #split>
                <span class="share" *ngFor="let share of shares(row.carriers?.[carrier])">
                  {{ share.provider_account?.name }} {{ share.percent }}%
                </span>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <small class="field-hint">
      Usa as rotas salvas: troque a rota, salve e atualize. Bloqueado quer dizer que a rota não tem conta onde a marca
      esteja ativa: o RCS não sai e o Admin recebe alerta. Para mudar a divisão, registre a marca em outro broker na Fila
      de agentes RCS ou troque a rota acima.
    </small>
  </div>
</section>
